import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin } from "lucide-react";
import { socialLinks } from "@/lib/siteData";

const footerLinks = [
  { label: "STUDIO RATES", to: "/rates" },
  { label: "FILM & PRODUCTION SERVICES", to: "/services" },
  { label: "PHOTOGRAPHY SERVICES", to: "/services" },
  { label: "REFUND AND RETURNS POLICY", to: "/studio-rules" },
  { label: "STUDIO RULES", to: "/studio-rules" },
];

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border">
      {/* Map + Contact */}
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="aspect-video lg:aspect-auto lg:min-h-[400px] overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3370.5!2d-84.98!3d32.46!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzLCsDI3JzM2LjAiTiA4NMKwNTgnNDguMCJX!5e0!3m2!1sen!2sus!4v1"
            width="100%"
            height="100%"
            style={{ border: 0, minHeight: 300 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="MyStudio Location"
          />
        </div>

        <div className="bg-surface p-8 lg:p-16 flex flex-col justify-center">
          <h3 className="text-xl font-display tracking-wider mb-6">Contact us</h3>
          <address className="not-italic text-sm text-muted-foreground font-body space-y-3 mb-8">
            <p>2300 Whittlesey Rd Ste E</p>
            <p>Columbus, GA 31909</p>
            <p>
              <a href="tel:7064787640" className="hover:text-foreground transition-colors">706.478.7640</a>
            </p>
            <p>
              <a href="mailto:services@bookmystudiospace.com" className="hover:text-foreground transition-colors">services@bookmystudiospace.com</a>
            </p>
          </address>
          <Link to="/contact" className="bg-primary text-primary-foreground px-6 py-2 font-display tracking-[0.15em] text-xs w-fit hover:bg-primary/90 transition-colors">
            CONTACT NOW
          </Link>
        </div>
      </div>

      {/* Links + Studio Image Section */}
      <div className="relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(/__l5e/assets-v1/16f70672-6eb2-4d50-809d-8650776cb94e/MyStudio_Instagram11.jpg)` }}
        />
        <div className="absolute inset-0 bg-background/80" />
        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2">
          <div className="p-8 lg:p-16 flex flex-col justify-center">
            <nav className="flex flex-col">
              {footerLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-primary font-display text-sm tracking-[0.15em] py-4 border-b border-border/50 hover:text-primary/80 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="hidden lg:block" />
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-border">
        <div className="container mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground font-body">
            Copyright {new Date().getFullYear()}, MyStudio Columbus, GA. All rights reserved
          </p>
          <div className="flex items-center gap-4">
            <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
              <Facebook className="w-4 h-4" />
            </a>
            <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Twitter">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="LinkedIn">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={socialLinks.pinterest} target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Pinterest">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.024 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>
            </a>
          </div>
        </div>
      </div>

      {/* Privacy Policy */}
      <div className="border-t border-border/50 py-3 text-center">
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-body">
          <Link to="/privacy-policy" className="text-muted-foreground hover:text-foreground transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="text-muted-foreground hover:text-foreground transition-colors">
            Terms of Service
          </Link>
          <Link to="/cookie-policy" className="text-muted-foreground hover:text-foreground transition-colors">
            Cookie Policy
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
